import { useEffect, useRef, useState } from 'react';

export default function Gallery() {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef<HTMLElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  return (
    <section
      id="gallery"
      ref={sectionRef}
      className="relative min-h-screen py-20 px-6 md:px-20"
    >
      <div className="max-w-7xl mx-auto">
        <div className="mb-12">
          <div
            className={`flex items-center gap-3 mb-4 transition-all duration-700 ${
              isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-5'
            }`}
          >
            <div className="w-1 h-1 bg-white rounded-full" />
            <span className="text-xs tracking-[0.2rem] text-white/50 uppercase">
              Timeline
            </span>
          </div>
          <h2
            className={`text-5xl font-extralight text-white transition-all duration-700 delay-200 ${
              isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-5'
            }`}
            style={{ fontWeight: 200 }}
          >
            TIME LINE
          </h2>
        </div>

        <div
          className={`text-lg text-white/60 transition-all duration-700 delay-400 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-5'
          }`}
        >
          <p className="max-w-2xl">
            We are currently architecting the next phase of the HigherEX experience. The timeline is being constructed. Check back soon for the official roadmap reveal.
          </p>
        </div>
      </div>
    </section>
  );
}
